{
  "version": 1,
  "asset_id": "87e8c5a4-02a8-41a8-b70c-0648337d3aa7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/87e8c5a4-02a8-41a8-b70c-0648337d3aa7/sleeve-to-bypass-first-view-en-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/87e8c5a4-02a8-41a8-b70c-0648337d3aa7/sleeve-to-bypass-first-view-en-320.webp",
  "original_filename": "sleeve-to-bypass-first-view-en-320.webp",
  "size": 11088,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:33:48Z"
}
